import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Card } from 'react-bootstrap';
import AppNavbar from '@/components/layout/AppNavbar';
import Footer from '@/components/layout/Footer';
import SignUpForm from '@/features/auth/components/SignUpForm';
import Nickname from '../components/IdolNickname';
import HeroSection from '../components/HeroSection';
import LandingSections from '../components/LandingSections';
import { setIdolId, setIdolUuid } from '@/shared/store/slices/userSlice';

export default function SignUpPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [showNickname, setShowNickname] = useState(false);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  const handleResponse = (res) => {
    dispatch(setIdolId(res.data.idol_id));
    dispatch(setIdolUuid(res.data.idol_uuid));
    navigate(`/idol-update/${res.data.idol_uuid}`);
  };

  return (
    <div>
      <AppNavbar />
      <div className="nav-padding-guest mb-5">
        <HeroSection>
          <Card className="shadow login-card mx-auto border-0 opacity-80 text-wrap">
            {showNickname ? (
              <Nickname onResponse={handleResponse} />
            ) : (
              <>
                <div className="loginbox-title text-center border-bottom position-relative">
                  <h2 className="p-3">{t("signup")}</h2>
                  <Link
                    to="/"
                    className="position-absolute text-decoration-underline link-primary h5 mb-0"
                    style={{ right: '24px', bottom: '24px' }}
                  >
                    {t("login")}
                  </Link>
                </div>
                <Card.Body className="py-2 px-4">
                  <SignUpForm onShowNickname={setShowNickname} />
                </Card.Body>
              </>
            )}
          </Card>
        </HeroSection>

        <LandingSections onScrollToTop={scrollToTop} />
      </div>
      <Footer />
    </div>
  );
}
